import { Injectable } from '@angular/core';
import { HTTP } from '@ionic-native/http';
import { ConfigurationManager } from './ConfigurationManager';
import { HttpClientService } from '../http/http-client.service';
import { HttpOptions } from '../http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CategoryProviderService {


    all_deals_encoded = 'All+Deals';

    constructor(private http1: HTTP, private http: HttpClientService, private config: ConfigurationManager) { }




    getCategorries(data): Observable<any> {


        const headers = { headers: {
            'Content-Type': 'application/json',
            'x-api-key': this.config.environmentConfig.apikey + '',
            'Accept': 'application/json'
        }};

        const params = {
            'Latitude': this.config.getLatitude + '',
            'Longitude': this.config.getLongitude + '',
            'SessionID': this.config.getSessionId,
            'ProxyUI': this.config.getProxyUI,
            'ClubID': this.config.getClubCode,
            'FromNewDNR': 'true',
        };
        const url = this.config.environmentConfig.baseurl + 'calst/v1';
        // let url="https://api.dnr.acg.aaa.com/calst/v1?Latitude=0.000000&Longitude=0.000000&SessionID=ffe46be4-6539-4e4a-8ada-dfdad5799cca&ClubID=047&ProxyUI=3014769368&FromNewDNR=true";

        return this.http.get(url, params, headers);

    }

}
